console.log("Shopify", Shopify);

let MIXPANEL_TOKEN = "80994a2fd86842ebe363f9e11e5c001e";
let MIXPANEL_PROXY_URL = "https://d2y9mfrjtk51ig.cloudfront.net"
let APP_PROXY_NAME = "vinyl-app";
let PROXY_BASE_URL = "https://shopify-proxy.vinyl.com";
let VINYL_API_BASE_URL = "https://api.vinyl.com";

// DEV
// MIXPANEL_TOKEN = "df1d0e78e02f8ee0f9af649530e0d235";
// APP_PROXY_NAME = "vinyl-app-dev";
// PROXY_BASE_URL = "http://localhost:8080"
// VINYL_API_BASE_URL = "http://localhost:3000"

// STAG
if (
  Shopify
  && Shopify.shop == "vinyl-staging.myshopify.com"
  && Shopify.theme
  && Shopify.theme.id
  // && Shopify.theme.id === 158390452529
) {
  MIXPANEL_TOKEN = "df1d0e78e02f8ee0f9af649530e0d235";
  APP_PROXY_NAME = "vinyl-app";
  PROXY_BASE_URL = "https://shopify-proxy-staging.vinyl.com";
  VINYL_API_BASE_URL = "https://api.vinyl.com";
}

// PROD
if (
    Shopify
    && Shopify.shop == "get-vinyl.myshopify.com"
    && Shopify.theme
    && Shopify.theme.id
    && Shopify.theme.id === 158390452529
) {
  MIXPANEL_TOKEN = "80994a2fd86842ebe363f9e11e5c001e";
  APP_PROXY_NAME = "vinyl-app";
  PROXY_BASE_URL = "https://shopify-proxy.vinyl.com";
  VINYL_API_BASE_URL = "https://api.vinyl.com";
}
